import { useEffect, useState } from "react"
import { LineChart } from '@mui/x-charts/LineChart';

const dateFormatter = Intl.DateTimeFormat(undefined, {
  month: '2-digit',
  day: '2-digit',
});
const oneDay = 24 * 60 * 60 * 1000;
const length = 50;
const initialFirstData = Array.from({ length }).map(
  (_, __, array) => (array.at(-1) ?? 0) + randBetween(-100, 500),
);
const initialSecondData = Array.from({ length }).map(
  (_, __, array) => (array.at(-1) ?? 0) + randBetween(-500, 100),
);

function Line4() {
  const [running, setRunning] = useState(true);
  const [date, setDate] = useState(new Date(2000, 0, 0));
  const [firstData, setFirstData] = useState(initialFirstData);
  const [secondData, setSecondData] = useState(initialSecondData);

  useEffect(() => {
    if (!running) {
      return undefined;
    }
    const intervalId = setInterval(() => {
      setDate((prev) => new Date(prev.getTime() + oneDay));
      setFirstData((prev) => [
        ...prev.slice(1),
        prev.at(-1) + randBetween(-500, 500),
      ]);
      setSecondData((prev) => [
        ...prev.slice(1),
        prev.at(-1) + randBetween(-500, 500),
      ]);
    }, 300);

    return () => {
      clearInterval(intervalId);
    };
  }, [running]);

  return (
    <div style={{ width: '100%' }}>
      <LineChart
        height={300}
        skipAnimation
        series={[
          { data: secondData, showMark: false, labelColor: 'white' },
          { data: firstData, showMark: false, labelColor: 'white' },
        ]}
        margin={{ right: 24 }}
        xAxis={[{ 
            scaleType: 'point', 
            data: Array.from({ length }).map(
              (_, i) => new Date(date.getTime() + i * oneDay),
            ),
            valueFormatter: (value) => dateFormatter.format(value),
            tickLabelStyle: { fill: 'white' },
        }]}
        yAxis={[{ 
            width: 50,
            tickLabelStyle: { fill: 'white' }, 
        }]}
      />
    </div>
  );
}

function randBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default Line4